// extracted by mini-css-extract-plugin
export default {"splitLayout":"styles_splitLayout__qx9Ym","internalRecWrap":"styles_internalRecWrap__SYk+6","wrapper":"styles_wrapper__YdyXE","content":"styles_content__jcPf3"};